<template>
    <div id="to-download" class="d-grid ga-10">
        <a
            v-for="file in files"
            :key="file.id"
            :href="file.url"
            target="_blank"
        >
            <v-card
                class="pa-4"
                elevation="0"
                border
                rounded="normal"
            >
                <div class="d-flex align-center ga-2">
                    <v-icon :icon="mdiFileMultipleOutline" size="24" color="orange"></v-icon>
                    <span class="text-decoration-underline">{{ file.variant_name?file.variant_name:file.filename }}</span>
                </div>
            </v-card>
        </a>
    </div>
</template>

<script setup>
import {mdiFileMultipleOutline} from "@mdi/js";
import {computed} from "vue";

const props = defineProps({
    files: Object
})

const files = computed(() => {
    if (props.files) {
        return Object.values(props.files);
    }
    return [];
})
</script>

<style scoped lang="scss">
#to-download {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}
</style>
